import React from 'react';

import { formatFloatNumber } from '@utils/Util';

const BaseSizeAndQtyModal = ({
	handleChange,
	validateNumber,
	qtyError,
	inputData,
	validateFloatNumber,
	handleUpdate,
	handleClose,
	sizeError,
	isPriceDisabled = true
}) => {
	return (
		<div className="base-size-and-quantity">
			<div className="size-and-quantity-details">
				<p className="regular-14 gray_dark_01 mb-2">Base size & qty</p>
				<div className="inputs d-flex">
					<input
						type="number"
						placeholder="Qty"
						name="moq"
						onKeyPress={validateNumber}
						onChange={handleChange}
						value={inputData?.moq || ''}
						className={qtyError ? 'common-border-error' : ''}
					/>
					<input
						type="text"
						autoComplete="off"
						placeholder="Size"
						name="baseSize"
						onChange={handleChange}
						value={inputData?.baseSize || ''}
						className={sizeError ? 'common-border-error' : ''}
					/>

					<input
						type="number"
						placeholder="Price"
						name="totalCost"
						onKeyPress={validateFloatNumber}
						onChange={handleChange}
						value={
							inputData.totalCost
								? isPriceDisabled
									? formatFloatNumber(inputData.totalCost)
									: inputData.totalCost
								: ''
						}
						disabled={isPriceDisabled}
					/>
				</div>
			</div>
			<div className="footer-buttons text-right mt-2">
				<span onClick={handleClose} className="regular-14 gray_dark_02 cursor-pointer">
					CANCEL
				</span>
				<span className="regular-14 primary_bright_01 ml-3 cursor-pointer" onClick={handleUpdate}>
					UPDATE
				</span>
			</div>
		</div>
	);
};

export default BaseSizeAndQtyModal;
